/* eslint-disable camelcase */
import classNames from "classnames";
import Button from "components/atoms/Button";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import { useTogglePopup } from "hooks/useTogglePopup";
import { useGTM } from "hooks/useGTM";
import { useBreakpoint } from "hooks/useBreakpoint";
// import { useAnalytics } from "hooks/useAmplitude";

import "./styles.sass";

const UserControlsNotAuth = () => {
  const GTM = useGTM();
  const { isDesktop } = useBreakpoint();
  const { openPopup } = useTogglePopup();
  // const { trackEvent, getLocationPathname, getCampainId } = useAnalytics();

  const notAuthControlsClassname = classNames("UserControlsNotAuth", {
    UserControlsNotAuth__mobile: !isDesktop,
  });

  const handleSignUpClick = () => {
    // Временно скрываем событие так как нет денег
    // trackEvent("registration_button_click", {
    //   eventPropertyKey: "registration_button_click",
    //   page_name: getLocationPathname(),
    //   button_location: "top",
    //   campaign_id: getCampainId(),
    // });

    GTM.openRegistration();
    openPopup(GET_POPUP_TYPES.popup.signUp);
  };

  const handleSignInClick = () => {
    GTM.openLogin();
    openPopup(GET_POPUP_TYPES.popup.signIn);
  };

  return (
    <div className={notAuthControlsClassname}>
      <Button
        variation="primary"
        label="header.sign.in"
        size={!isDesktop ? "s" : "m"}
        dataCy="header-sign-in-button"
        widthContent={!isDesktop}
        onClick={handleSignInClick}
      />
      <Button
        variation="gradient"
        label="header.sign.up"
        size={!isDesktop ? "s" : "m"}
        widthContent={!isDesktop}
        blick
        onClick={handleSignUpClick}
      />
    </div>
  );
};

export default UserControlsNotAuth;
